export const formatFooterData = (data = []) => {
  const links = [];
  if (data) {
    Object.keys(data).forEach((group) => {
      let subGroup = '';
      Object.keys(data[group]).forEach((ele) => {
        if (typeof data[group][ele] !== 'object') {
          subGroup = data[group][ele];
          links[subGroup] = [];
        } else {
          let link = data[group][ele][0][0].replaceAll('&amp;', '&');
          let url = depurateURL(data[group][ele][0][1]);
          links[subGroup][link] = url;
        }
      });
    });
  }
  return links;
};

function depurateURL(url) {
  // Remove any attribute from string
  url = (url.split('"').length > 1) ? url.split('"')[0] : url;

  if (url.includes('quicken.com/')) {
    return process.env.REACT_APP_STORE_URL + url.split('quicken.com')[1];
  } else {
    return (url.includes('https://')) ? url :  process.env.REACT_APP_STORE_URL + url;
  }
}
